
import {
  defineComponent,
  useFetch,
  computed,
  useRoute,
  useMeta,
} from '@nuxtjs/composition-api';
import CategoryMainSection from '~/domains/category/components/CategoryMainSection';
import useFetchCategory from '~/composables/useFetchCategory';
import useAlternateLinks from '~/composables/useAlternateLinks';
import useFilter from '~/composables/useFilter';

export default defineComponent({
  components: { CategoryMainSection },
  head: {},
  setup() {
    const { PAGE_MAX_PRODUCTS, category, isLoading, fetchCategoryBySlug } =
      useFetchCategory();
    const route = useRoute();
    const { getQueryParams } = useFilter();
    const currentPage = computed(() => route.value?.query?.page);
    const slugName = route.value.params.slug;
    const { alternateLinks } = useAlternateLinks();

    const seoData = computed({
      get() {
        if (!category.value) return null;

        const data = category.value.contents.find(
          (block) => block.type === 'app-seo-section'
        );

        return data && data.data;
      },
      set() {},
    });

    const totalPages = computed({
      get() {
        if (!category.value) return null;

        return Math.ceil(
          category.value.products_meta_count / PAGE_MAX_PRODUCTS
        );
      },
      set() {},
    });

    const handleChangePage = async () => {
      await fetchCategoryBySlug(slugName, { page: currentPage.value });
    };

    const normalizeFilterQuery = (queryParams) => {
      const { page, limit, ...filterParams } = queryParams;
      const filters =
        typeof filterParams === 'object'
          ? Object.values(filterParams).flat()
          : undefined;
      return {
        page,
        limit,
        filters,
      };
    };

    const fetchCategoryByFilter = async (queryParams) => {
      await fetchCategoryBySlug(slugName, normalizeFilterQuery(queryParams));
    };

    useFetch(async () => {
      await fetchCategoryBySlug(
        slugName,
        normalizeFilterQuery(getQueryParams.value)
      );
    });

    useMeta(() => ({
      title: category?.value?.seo?.page_title,
      meta: [
        {
          name: 'description',
          hid: 'description',
          content: category?.value?.seo?.description,
        },
        {
          property: 'og:title',
          hid: 'og:title',
          content: category?.value?.seo?.og_title,
        },
      ],
      link: alternateLinks.value,
    }));

    return {
      isLoading,
      totalPages,
      category,
      seoData,
      handleChangePage,
      fetchCategoryByFilter,
    };
  },
});
